var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-auto flex flex-col"},[_c('AddNewUser'),_c('ChangeGarmentColorPricing'),_c('ChangeSetupFee'),_c('ChangeAddlOptionsPricing'),_c('ChangeColorPricing')],1)}
var staticRenderFns = []

export { render, staticRenderFns }